
import React from 'react'
import img from "../../assets/homie-family.jpeg"
const NotfoundHero = () => {
  return (
   <section className='pt-[88px]'>
     <section className="hero notfound ">
        <section className='bg-[#5146AE80] h-full w-full'>
<div className='w-[80%] mx-auto'>

</div>
        </section>
    </section>
   </section>
  )
}

export default NotfoundHero